import React from 'react';
import PropTypes from 'prop-types';
import Text from '../Text';
export default function Placeholder(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Text, {
    color: "placeholder",
    size: "inherit"
  }, children);
}
Placeholder.propTypes = {
  children: PropTypes.node
};
Placeholder.defaultProps = {
  children: null
};